import {
  Avatar,
  Box,
  Collapse,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import { ItemMenuMb } from "./ItemMenuMb";
import { ItemOptionMb } from "./ItemOptionMb";
import {
  BoxProduct,
  Catalog,
  CatalogFile,
  Close,
  Home,
  Message,
  Users,
} from "../../../icons";
import { ItemSelectedMb } from "./ItemSelectedMb";
import { useState } from "react";
import avatar from "../../../assets/avatar.webp";
import { useLocation } from "react-router-dom";
import {
  accessories,
  apparel,
  collections,
  discounts,
  footwear,
  trainingTools,
} from "../../../helpers/Const";

type DrawerMenuMbProps = {
  open?: boolean;
  onClose: () => void;
};

const getStyle = (theme: Theme) => {
  const avatar: SxProps<Theme> = {
    width: 28,
    height: 28,
    border: `solid 2px ${theme.palette.primary[700]}`,
  };
  return { avatar };
};

export const DrawerMenuMb = ({ open, onClose }: DrawerMenuMbProps) => {
  const theme = useTheme();
  const styles = getStyle(theme);
  const location = useLocation();

  const [openCategory, setOpenCategory] = useState(false);
  const [openCollection, setOpenCollection] = useState(false);
  const [openDanceShoes, setOpenDanceShoes] = useState(false);
  const [openDanceWear, setOpenDanceWear] = useState(false);
  const [openAccessories, setOpenAccessories] = useState(false);

  const [openDiscounts, setOpenDiscounts] = useState(false);

  const onOpenMenuP = () => {
    setOpenCategory(!openCategory);
    openCategory && setOpenCollection(false);
    openCategory && setOpenDanceShoes(false);
    openCategory && setOpenDanceWear(false);
    openCategory && setOpenAccessories(false);
    openDiscounts && setOpenDiscounts(false);
  };

  const onDiscounts = () => {
    setOpenDiscounts(!openDiscounts);
  };

  const onCollection = () => {
    setOpenCollection(!openCollection);
  };
  const onDanceShoes = () => {
    setOpenDanceShoes(!openDanceShoes);
  };
  const onDanceWear = () => {
    setOpenDanceWear(!openDanceWear);
  };
  const onAccessories = () => {
    setOpenAccessories(!openAccessories);
  };

  const onLogin = () => {
    window.location.href = "https://shopify.com/77095928084/account";
  };
  const activeIconMb = (path: string) => {
    return location.pathname === path
      ? theme.palette.primary[800]
      : theme.palette.secondary[500];
  };
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          style: {
            width: "100%",
            height: "70%",
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            backgroundColor: theme.palette.background.default,
          },
        },
      }}
    >
      <Box height="100%" role="presentation">
        <List sx={{ padding: 0 }}>
          <ListItem disablePadding>
            <ListItemButton
              onClick={onLogin}
              sx={{
                display: "flex",
                borderRadius: "0px !important",
                backgroundColor: "white !important",
                gap: 2,
                paddingBlock: 3,
              }}
            >
              <Avatar src={avatar} alt="avatar" sx={styles.avatar} />
              <Typography variant="subtitle2">Profile</Typography>
            </ListItemButton>
            <IconButton sx={{ marginInline: 1 }} onClick={onClose}>
              <Close />
            </IconButton>
          </ListItem>
        </List>
        <Divider />
        <List>
          <ItemMenuMb onClick={onClose} primary="Home" to="/">
            <Home
              sx={{ width: 20, height: 20 }}
              htmlColor={activeIconMb("/")}
            />
          </ItemMenuMb>
          <ItemMenuMb onClick={onClose} primary="Store" to="/store">
            <CatalogFile
              sx={{ width: 20, height: 20 }}
              htmlColor={activeIconMb("/store")}
            />
          </ItemMenuMb>
          <ItemOptionMb
            isOpen={openCategory}
            onClick={onOpenMenuP}
            label="Categories"
          >
            <BoxProduct sx={{ width: 20, height: 20 }} />
          </ItemOptionMb>

          <Collapse in={openCategory} timeout="auto" unmountOnExit>
            <ItemSelectedMb
              isOpen={openCollection}
              onClick={onCollection}
              label="footwear"
            />
          </Collapse>
          <Collapse in={openCollection} timeout="auto" unmountOnExit>
            {footwear.map((c) => (
              <ItemMenuMb
                key={c.id}
                onClick={onClose}
                secondary={c.item}
                to={`${c.to}/${c.toName}`}
              />
            ))}
          </Collapse>

          <Collapse in={openCategory} timeout="auto" unmountOnExit>
            <ItemSelectedMb
              isOpen={openDanceShoes}
              onClick={onDanceShoes}
              label="Apparel"
            />
          </Collapse>
          <Collapse in={openDanceShoes} timeout="auto" unmountOnExit>
            {apparel.map((d) => (
              <ItemMenuMb
                key={d.id}
                onClick={onClose}
                secondary={d.item}
                to={`${d.to}/${d.toName}`}
              />
            ))}
          </Collapse>

          <Collapse in={openCategory} timeout="auto" unmountOnExit>
            <ItemSelectedMb
              isOpen={openDanceWear}
              onClick={onDanceWear}
              label="Collections"
            />
          </Collapse>
          <Collapse in={openDanceWear} timeout="auto" unmountOnExit>
            {collections.map((d) => (
              <ItemMenuMb
                key={d.id}
                onClick={onClose}
                secondary={d.item}
                to={`${d.to}/${d.toName}`}
              />
            ))}
          </Collapse>

          <Collapse in={openCategory} timeout="auto" unmountOnExit>
            <ItemSelectedMb
              isOpen={openAccessories}
              onClick={onAccessories}
              label="Accessories"
            />
          </Collapse>
          <Collapse in={openAccessories} timeout="auto" unmountOnExit>
            {accessories.map((a) => (
              <ItemMenuMb
                key={a.id}
                onClick={onClose}
                secondary={a.item}
                to={`${a.to}/${a.toName}`}
              />
            ))}
          </Collapse>

          <Collapse in={openAccessories} timeout="auto" unmountOnExit>
            {trainingTools.map((a) => (
              <ItemMenuMb
                key={a.id}
                onClick={onClose}
                secondary={a.item}
                to={`${a.to}/${a.toName}`}
              />
            ))}
          </Collapse>

          <Collapse in={openCategory} timeout="auto" unmountOnExit>
            <ItemSelectedMb
              isOpen={openDiscounts}
              onClick={onDiscounts}
              label="Discounts"
            />
          </Collapse>
          <Collapse in={openDiscounts} timeout="auto" unmountOnExit>
            {discounts.map((c) => (
              <ItemMenuMb
                key={c.id}
                onClick={onClose}
                secondary={c.item}
                to={`${c.to}/${c.toName}`}
              />
            ))}
          </Collapse>

          <ItemMenuMb
            onClick={onClose}
            primary="Contributors"
            to="/influencers"
          >
            <Users
              sx={{ width: 20, height: 20 }}
              htmlColor={activeIconMb("/influencers")}
            />
          </ItemMenuMb>

          <ItemMenuMb onClick={onClose} primary="Catalog" to="/catalog">
            <Catalog
              sx={{ width: 20, height: 20 }}
              htmlColor={activeIconMb("/catalog")}
            />
          </ItemMenuMb>

          <ItemMenuMb onClick={onClose} primary="Contact" to="/contact">
            <Message
              sx={{ width: 20, height: 20 }}
              htmlColor={activeIconMb("/contact")}
            />
          </ItemMenuMb>
        </List>
      </Box>
    </Drawer>
  );
};
